module.exports = __webpack_public_path__ + "img/product1.25c13119.png";